import { Component } from '@angular/core';

@Component({
  selector: 'cwa-welcome',
  template: `
    <div class="flex align-items-center justify-content-center" style="min-height: 70vh;">
      <div class="text-center">
        <img
          src="assets/images/png/logo.png"
          alt="Logo"
          class="mb-4"
          style="max-width: 300px; height: auto;"
        />
        <h1 class="text-6xl font-bold mb-3">Welcome to Cogwheel Analytics</h1>
      </div>
    </div>
  `,
  standalone: true,
})
export class WelcomeComponent {}
